import { render, staticRenderFns } from "./WhatsAppMessages.vue?vue&type=template&id=322d2e0e"
import script from "./WhatsAppMessages.vue?vue&type=script&lang=js"
export * from "./WhatsAppMessages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('322d2e0e')) {
      api.createRecord('322d2e0e', component.options)
    } else {
      api.reload('322d2e0e', component.options)
    }
    module.hot.accept("./WhatsAppMessages.vue?vue&type=template&id=322d2e0e", function () {
      api.rerender('322d2e0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/WhatsAppMessages.vue"
export default component.exports